<template>
  <Head title="Register" />
  <div class="hold-transition register-page">
    <div class="register-box">
      <div class="card card-outline card-primary">
        <div class="card-header text-center">
          <a href="#" class="h1">
            <b>KUNJUNGAN</b>
          </a>
        </div>
        <div class="card-body">
          <p class="login-box-msg">Daftarkan keanggotaan baru</p>
          <form @submit.prevent="submit">
            <input-group placeholder="Nama Lengkap" class="fas fa-user" v-model="form.name" :error="form.errors.name" />
            <input-group placeholder="Email" class="fas fa-envelope" v-model="form.email" :error="form.errors.email" />
            <input-group placeholder="Sandi" class="fas fa-lock" v-model="form.password" :error="form.errors.password"
              type="password" />
            <input-group placeholder="Ulangi Sandi" class="fas fa-lock" v-model="form.password_confirmation"
              :error="form.errors.password_confirmation" type="password" />

            <div class="row">
              <div class="col-8">
                <div class="icheck-primary">
                  <input type="checkbox" id="agreeTerms" v-model="form.terms" />
                  <label for="agreeTerms">
                    setuju dengan
                    <a href="#">ketentuan</a>
                  </label>
                </div>
              </div>

              <div class="col-4">
                <button type="submit" class="btn btn-primary btn-block" :disabled='isDisabled'>Daftar</button>
              </div>
            </div>
          </form>

          <a href="/login" class="text-center">
            Saya sudah memiliki keanggotaan
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import InputGroup from '@/Forms/InputGroup'

export default {
  components: {
    Head,
    InputGroup,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        terms: false,
      }),
    }
  },
  methods: {
    submit() {
      this.form.post('/register', {
        preserveScroll: true,
        onSuccess: (page) => {
          window.location.reload()
        },
      })
    },
  },
  computed: {
    isDisabled: function () {
      return !this.form.terms
    },
  },
}
</script>

<style>
.register-page {
  /* The image used */
  /* background-image: url("/background.jpg"); */
  background: rgba(0, 0, 0, .65) url("/default/background.jpg");
  background-blend-mode: darken;

  /* Control the height of the image */
  min-height: 380px;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
